<script>
  import { fade } from "svelte/transition";
  import { category_tags } from "../stores/stores";
  /**
   * @typedef {Object} Props
   * @property {string} [tags]
   */

  /** @type {Props} */
  let { tags = "" } = $props();
  let tag_array = $derived(tags ? tags.toLowerCase().split(";") : []);
</script>

<ul class="tag__list">
  {#each tag_array as tag, index}
    <li class="tag__list-item">
      <button
        transition:fade|global
        class={$category_tags[tag] ? "btn-tag active" : "btn-tag"}
        onclick={() => {
          category_tags.toggle(tag);
        }}
      >
        {tag}
      </button>
    </li>
  {/each}
</ul>

<style>
  .tag__list {
     display: flex;
     align-items: center;
     justify-content: flex-start;
     flex-wrap: wrap;
     list-style: none;
     padding: 0;
     margin: 20px 0 10px 20px;
     flex: 1 1 100%;
     width: 100%;
     max-width: calc(100% - 40px);
     height: auto;
  }
   .tag__list-item {
     margin: 0 10px 10px 0;
  }
   .btn-tag {
     border: 1px solid #6e6e6e;
     border-radius: 4px;
     display: flex;
     align-items: center;
     justify-content: center;
     height: 30px;
     padding: 0 20px;
     line-height: 0;
     color: #6e6e6e;
     text-transform: uppercase;
     font: Bold 10px/20px Arial;
     text-align: center;
     transition: background-color 0.2s ease;
     cursor: pointer;
     text-decoration: none;
  }
   .btn-tag:hover {
     color: #333;
  }
   .btn-tag:focus {
     color: #fff;
     background: #5c5c5c;
  }
   .active {
     border: none;
     color: #fff;
     background: #333;
  }
   .active:hover {
     background: #fff;
     color: #6e6e6e;
  }
   
  </style>
